import React from 'react';
import { useRouter } from 'next/router';
import { useAndroidWelcome } from '../../lib/androidWelcome';
import PushSettings from './PushSettings';
import styles from './PushSettings.module.scss';

export default function PushReminder() {
  const { pathname } = useRouter();
  const androidWelcome = useAndroidWelcome();
  let context: 'home' | 'league' | 'match';
  if (pathname === '/') context = 'home';
  else if (['/ligler/[id]', '/cift-ligler/[id]', '/business-ligler/[id]'].includes(pathname)) context = 'league';
  else if (pathname === '/oyna/[id]') context = 'match';
  else return null;
  // Android karşılaması açıkken bildirim izni oradan istenir.
  if (androidWelcome.active) return null;

  return <div className={styles.reminderLayout}><PushSettings compact context={context} /></div>;
}
